<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<v-row no-gutters justify="end">
				<v-btn
					class="mt-2 ml-2"
					color="secondary"
					tag="a"
					:to="{ name: 'check_sheet_template_edit', params: { id } }"
				>
					<v-icon class="mr-1">mdi-pencil</v-icon>
					編集
				</v-btn>
				<TemplateDeleteDialog :openBtnClass="'mt-2 ml-2'">
					<template v-slot:btn-text> 削除 </template>
				</TemplateDeleteDialog>
			</v-row>

			<ConfirmationSection
				v-if="approval_authority_flag"
				:name="'チェックシートテンプレート'"
				:status="check_sheet_template.status_i18n"
				:actionName="actionName"
				:requiredConfirmationDialog="false"
				@accept="openConfirmationDialog"
				@reject="rejectCheckSheetTemplate($event)"
			/>

			<v-row no-gutters>
				<v-col sm="6" cols="12" class="pr-sm-1">
					<v-sheet elevation="0">
						<table width="100%" class="show-dialog-table">
							<tbody>
								<ShowDetailRecord
									:columnName="'シート番号'"
									:value="check_sheet_template.template_number"
								/>
								<ShowDetailRecord :columnName="'シート名'" :value="check_sheet_template.name" />
								<ShowDetailRecord
									:columnName="'シート状態'"
									:value="check_sheet_template.status_i18n"
								/>
							</tbody>
						</table>
					</v-sheet>
				</v-col>
				<v-col sm="6" cols="12" class="pl-sm-1">
					<v-sheet elevation="0">
						<table width="100%" class="show-dialog-table">
							<tbody>
								<ShowDetailRecord :columnName="'表示バージョン'">
									<template v-slot:value>
										<v-select
											v-if="related_templates.length > 1"
											v-model="versionId"
											:items="related_templates"
											item-value="id"
											item-text="name"
											outlined
											dense
											hide-details
											@change="changeTemplateVersion"
										/>
										<p v-else>最新版</p>
									</template>
								</ShowDetailRecord>
							</tbody>
						</table>
					</v-sheet>
				</v-col>
			</v-row>
			<v-sheet elevation="0" class="my-4 table-container">
				<table width="100%" class="show-dialog-table">
					<tbody>
						<th class="font-weight-bold" :style="width(100)">QC番号</th>
						<th class="font-weight-bold" :style="width(150)">作業工程</th>
						<th class="font-weight-bold" :style="width(200)">チェック項目</th>
						<th class="font-weight-bold" :style="width(200)">チェック方法</th>
						<th class="font-weight-bold" :style="width(200)">チェック基準</th>
						<th class="font-weight-bold" :style="width(200)">保存結果のデータ形式</th>
					</tbody>
					<tbody>
						<tr v-for="item in check_sheet_template.check_items" :key="item.id">
							<td>
								{{ item.qc_number }}
							</td>
							<td>
								{{ item.small_process_type.name }}
							</td>
							<td>
								{{ item.name }}
							</td>
							<td>
								{{ item.check_method }}
							</td>
							<td>
								{{ item.standard }}
							</td>
							<td>
								{{ item.data_type }}
							</td>
						</tr>
					</tbody>
				</table>
			</v-sheet>
			<CheckSheetTemplateConfirmationDialog
				:dialog.sync="confirmation_flag"
				:checkSheetTemplate="check_sheet_template"
				@accept="acceptCheckSheetTemplate($event)"
			/>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import TemplateDeleteDialog from "../shared/TemplateDeleteDialog.vue"
import ConfirmationSection from "../shared/ConfirmationSection.vue"
import ShowDetailRecord from "../shared/ShowDetailRecord.vue"
import CheckSheetTemplateConfirmationDialog from "./components/CheckSheetTemplateConfirmationDialog.vue"

export default {
	components: {
		CommonFlame,
		TemplateDeleteDialog,
		ConfirmationSection,
		ShowDetailRecord,
		CheckSheetTemplateConfirmationDialog,
	},
	data() {
		return {
			title: "チェックシートテンプレート一覧",
			id: this.$route.params.id,
			check_sheet_template: {
				check_items: [],
				user: {},
			},
			versionId: null,
			related_templates: [],
			confirmation_flag: false,
			authority_flag: false,
			approval_authority_flag: false,
			common,
		}
	},

	mounted() {
		this.fetchCheckSheetTemplate()
	},
	methods: {
		fetchCheckSheetTemplate() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/check_sheet_templates/${this.id}`
			axios
				.get(url, {
					headers,
				})
				.then((res) => {
					this.check_sheet_template = res.data.check_sheet_template
					this.related_templates = res.data.related_templates.map((item) => {
						return {
							id: item.id,
							name: common.formatDate(this.check_sheet_template.updated_at) + "更新版",
						}
					})
					if (this.related_templates.length > 0) {
						this.versionId = this.id
					}
					this.authority_flag = res.data.authority_flag
					this.approval_authority_flag = res.data.approval_authority_flag
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		changeTemplateVersion() {
			// TODO
		},
		openConfirmationDialog() {
			this.confirmation_flag = true
		},
		acceptCheckSheetTemplate(checkSheetTemplate) {
			// TODO: 承認・確認
		},
		rejectCheckSheetTemplate() {
			// TODO: 差し戻し
			const headers = authenticate.setHeader()
			const url = `/erp/v1`
			axios
				.delete(url, {
					headers,
				})
				.then((res) => {})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		width(width) {
			return { width: width + "px", minWidth: width + "px", maxWidth: width + "px" }
		},
	},
	computed: {
		actionName() {
			if (this.check_sheet_template.status == "approval_pending") {
				return "承認"
			} else if (this.check_sheet_template.status == "confirmation_pending") {
				return "確認"
			} else {
				return ""
			}
		},
	},
}
</script>
